import { Cart } from './';
import { CalculatedCart, CalculatedCartDelivery } from './selectors';

import { Decimal } from 'decimal.js';
import {
  Currency,
  OrderAddressInput,
  OrderDataInput,
  OrderDeliveryInput,
} from './types';
import { getAdjustedDeliveryTime } from './getAdjustedDeliveryTime';

export const totalCartPrice = (cart: Cart | null) => {
  if (!cart) return { orderTotal: 0, hasZeroPricedItem: false };

  let orderTotal = new Decimal(0);
  let hasZeroPricedItem = false;

  Object.values(cart?.deliveries || {}).forEach((delivery) => {
    Object.values(delivery.items).forEach((item) => {
      const itemPrice = item.price || 0;
      orderTotal = orderTotal.add(new Decimal(item.amount || 1).mul(itemPrice));

      if (itemPrice === 0) {
        hasZeroPricedItem = true;
      }
    });
  });

  return { orderTotal: orderTotal.toNumber(), hasZeroPricedItem };
};

export function cartToOrderDataInput(
  cart: CalculatedCart,
   
  billingAddress: OrderAddressInput,
  options?: {
    ignoreVolumeDiscounts?: boolean;
  },
): OrderDataInput {
  function formatCartDelivery(
    delivery: CalculatedCartDelivery,
  ): OrderDeliveryInput {
    const adjustedDeliveryTime = getAdjustedDeliveryTime(
      delivery.deliveryFrom,
      delivery.deliveryTime
    );

    return {
      locationID: delivery.locationId.toString(),
      comments: delivery.comment,
      siloID: delivery.siloId ? delivery.siloId.toString() : undefined,
      deliveryFrom: delivery.deliveryFrom,
      deliveryTo: delivery.deliveryTo,
      deliveryTime: adjustedDeliveryTime,
      // https://agrantis.atlassian.net/browse/AG-4103
      // deliveryAddress: delivery.deliveryAddress || billingAddress, // hacky fix to set the pickup address to the billing address as this is required by the ERPs
      items: Object.values(delivery.items)
      .sort((a, b) => a.addedAt - b.addedAt) // Sort by added time
      .map((i) => ({
        catalogueID: i.itemData.articleId.toString(),
        inventoryID: i.itemData.id.toString(),
        amount: i.itemData.quantity,
        quantity: i.amount,
        taxRate: i.itemData.taxRate,
        unit: i.itemData.unit,
        name: i.itemData.articleName,
        basePrice: i.price,
        price: options?.ignoreVolumeDiscounts
          ? i.price
          : i.discountedPrice ?? i.price,
        lineTotalNet: i.lineDiscountedTotalNet ?? i.lineTotalNet,
        lineTotalGross: i.lineDiscountedTax
          ? i.lineDiscountedTotalNet! + i.lineDiscountedTax
          : i.lineTotalGross,
      })),
      type: delivery.type,
    };
  }

  const payload = {
    // billingAddress, https://agrantis.atlassian.net/browse/AG-4103
    currency: Currency.Eur,
    deliveries: Object.values(cart.deliveries).map(formatCartDelivery),
  };
  return payload;
}
